export const Projects = [
	{
		id: 1,
		name: 'Chimera-X',
		tags: ['Next.js', 'Express', 'MUI', 'GraphQL', 'TypeScript', 'FireBase'],
		date: 'Jan, 2023 - Mar. 2023',
		imgSrc: 'https://i.postimg.cc/pL5t4d2R/chimerax.png',
		LiveLink: 'https://chimerax23-ui.vercel.app/',
		GithubLink: 'https://github.com/ISTE-SC-MANIT/chimerax23-ui',
		dsc: 'A platform to conduct one of the largest INTER NIT Quizzing Competition',
	},

	{
		id: 2,
		name: 'PulseChat',
		tags: ['Next.js', 'Express', 'ChakraUI', 'Socket.io', 'TypeScript'],
		date: 'Oct. 2023 - Oct. 2023',
		imgSrc: 'https://i.postimg.cc/tggMZqg8/live-chatting.png',
		LiveLink: 'https://pulse-chat-client.vercel.app/',
		GithubLink: 'https://github.com/jake8989/pulse-chat-client',
		dsc: 'Real Time Chat Application for private chatting',
	},
	{
		id: 3,
		name: 'BaySick',
		tags: ['Next.js', 'Express', 'MUI', 'MongoDB'],
		date: 'June 2023 - July 2023',
		imgSrc: 'https://i.postimg.cc/mrQWZ6zn/baysick.png',
		LiveLink: 'https://baysick-client.vercel.app',
		GithubLink: 'https://github.com/jake8989/baysick-client',
		dsc: 'An E-Commerce Platform for selling T-shirts ',
	},
	{
		id: 4,
		name: 'GamesWave',
		tags: ['Next.js', 'MUI', 'TypeScript'],
		date: 'Nov. 2023 - Nov. 2023',
		imgSrc:
			'https://media.rawg.io/media/games/364/3642d850efb217c58feab80b8affaa89.jpg',
		LiveLink: 'https://gameswave.vercel.app/',
		GithubLink: 'https://github.com/jake8989/gameswave',
		dsc: 'A Dynamic Game Searching Application',
	},
	{
		id: 5,
		name: 'ISTESCMANIT',
		tags: ['React.js', 'MUI', 'JavaScript'],
		date: 'Dec 2022 Dec 2022',
		imgSrc: '',
		LiveLink: '',
		GithubLink: 'https://github.com/ISTE-SC-MANIT/main-website22',
		dsc: 'Official Website for ISTESCMANIT',
	},
	{
		id: 6,
		name: 'TedXManit',
		tags: ['React.js', 'MUI', 'JavaScript'],
		date: 'Jan 2023 Jan 2023',
		imgSrc: 'https://i.postimg.cc/vZCGZVP4/tedx.png',
		LiveLink: 'https://tedxmanitbhopal.istemanit.in/',
		GithubLink: 'https://github.com/jake8989/tedxmanit',
		dsc: 'Official Website for TedXManit',
	},
];
